import { useEffect, useRef } from "react";
import env from "../config/env";
import { ShiftApplication } from '../components/ShiftApplicationIndicator';

/**
 * Interface for shift assignment object structure
 */
export interface ShiftAssignment {
  id: number;
  shift: number;
  employee: number;
  assignment_id?: number;
  employee_name?: string;
  [key: string]: any; // Allow for additional properties that might come from the API
}

/**
 * Interface for application deletion data
 */
export interface ApplicationDeletedData {
  id: string | number;
  shift?: number;
  employee?: number;
  [key: string]: any; // Allow for additional properties that might come from the API
}

/**
 * Interface for useShiftWS hook parameters
 */
export interface UseShiftWSParams {
  onNewApplication?: (appData: ShiftApplication) => void;
  onNewAssignment?: (assignData: ShiftAssignment) => void;
  onApplicationDeleted?: (delData: ApplicationDeletedData) => void;
}

/**
 * useShiftWS:
 *  - Stellt eine WebSocket-Verbindung zu /ws/shifts/ her
 *  - Ermöglicht dir, Callback-Funktionen zu registrieren,
 *    um auf neue SHIFTAPPLICATIONS (onNewApplication),
 *    SHIFTASSIGNMENTS (onNewAssignment),
 *    sowie SHIFTAPPLICATION-Deletes (onApplicationDeleted) zu reagieren.
 *
 * Beispiel:
 *   useShiftWS({
 *     onNewApplication: (appData) => { ... },
 *     onNewAssignment: (assignData) => { ... },
 *     onApplicationDeleted: (delData) => { ... }
 *   });
 */
export default function useShiftWS({
  onNewApplication,
  onNewAssignment,
  onApplicationDeleted
}: UseShiftWSParams): null {
  const socketRef = useRef<WebSocket | null>(null);

  useEffect(() => {
    // Use the API_URL from env.js
    const apiUrl: string = `${env.API_URL}/api/shifts/`;
    
    console.log("[useShiftWS] API URL configured:", apiUrl);

    // Simulate the functionality that was previously handled via WebSockets
    // You should implement appropriate HTTP polling or other mechanisms here
    const fetchData = (): void => {
      // Your HTTP implementation goes here
      console.log("[useShiftWS] This module has been modified to use HTTP instead of WebSockets");
    };
    
    fetchData();
    
    // Cleanup
    return (): void => {
      console.log("[useShiftWS] Cleanup");
    };
  }, [onNewApplication, onNewAssignment, onApplicationDeleted]);

  // Kein eigenes UI-Element => return null
  return null;
} 